import { render, staticRenderFns } from "./addtocatalog-piececontent.vue?vue&type=template&id=2b5c89bc&scoped=true&"
import script from "./addtocatalog-piececontent.vue?vue&type=script&lang=js&"
export * from "./addtocatalog-piececontent.vue?vue&type=script&lang=js&"
import style0 from "./addtocatalog-piececontent.vue?vue&type=style&index=0&id=2b5c89bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5c89bc",
  null
  
)

export default component.exports